// This file contains simple initializers intended to be used for
// deserialization. This covers cases when new properties are added to the
// interface that are not present in the serialized data. If you want to do data
// migration, such as transforming a property value, you should use more
// advanced migration functions instead.
export function initializeSemanticModelClass(entity) {
    return {
        id: "",
        type: ["class"],
        iri: null,
        name: {},
        description: {},
        nameProperty: null,
        descriptionProperty: null,
        order: null,
        externalDocumentationUrl: null,
        ...entity,
    };
}
export function initializeSemanticModelRelationshipEnd(end) {
    return {
        iri: null,
        name: {},
        description: {},
        nameProperty: null,
        descriptionProperty: null,
        order: null,
        // Undefined cardinality is unknown
        // Many semantic models do not specify cardinality
        cardinality: undefined,
        concept: null,
        externalDocumentationUrl: null,
        ...end,
    };
}
export function initializeSemanticModelRelationship(entity) {
    return {
        id: "",
        type: ["relationship"],
        iri: null,
        name: {},
        description: {},
        nameProperty: null,
        descriptionProperty: null,
        ...entity,
        ends: entity.ends ?
            entity.ends.map(end => initializeSemanticModelRelationshipEnd(end)) :
            [
                initializeSemanticModelRelationshipEnd({}),
                initializeSemanticModelRelationshipEnd({}),
            ],
    };
}
export function initializeSemanticModelGeneralization(entity) {
    return {
        id: "",
        type: ["generalization"],
        iri: null,
        child: "",
        parent: "",
        ...entity,
    };
}
//# sourceMappingURL=entity-initializers.js.map